// Locate the actual tapped word without inserting spans or changing book layout.
export function wordAtPoint(block,x,y){
  const walker=block.ownerDocument.createTreeWalker(block,NodeFilter.SHOW_TEXT);
  let node,offset=0;
  while((node=walker.nextNode())){
    for(const match of node.textContent.matchAll(/\S+/gu)){
      const range=block.ownerDocument.createRange();range.setStart(node,match.index);range.setEnd(node,match.index+match[0].length);
      if([...range.getClientRects()].some(r=>x>=r.left&&x<=r.right&&y>=r.top&&y<=r.bottom))return {offset:offset+match.index,word:match[0]};
    }
    offset+=node.textContent.length;
  }
  return null;
}

// Optional recording timestamps use block IDs and UTF-16 word offsets.
export function timestampFor(target,timings=[]){
  const matches=timings.filter(cue=>cue.block===target.blockId&&Number.isFinite(cue.start)).sort((a,b)=>(a.offset||0)-(b.offset||0));
  // A caption may omit a paragraph's opening word. Its first recorded word is
  // a better starting point than jumping to the beginning of the chapter.
  return (matches.filter(cue=>(cue.offset||0)<=target.offset).at(-1)||matches[0])?.start;
}

// Boundaries are UTF-16 offsets, matching speech events and recording timestamps.
export function sentenceStarts(text,language='en'){
  let segments;
  if(typeof Intl.Segmenter==='function'){
    let segmenter;try{segmenter=new Intl.Segmenter(language,{granularity:'sentence'});}catch{segmenter=new Intl.Segmenter('en',{granularity:'sentence'});}
    segments=[...segmenter.segment(text)].map(({segment,index})=>({text:segment,index}));
  }else segments=[...text.matchAll(/[^.!?。！？]+(?:[.!?。！？]+[”’"']*|$)/gu)].map(match=>({text:match[0],index:match.index}));
  return segments.filter(segment=>segment.text.trim()).map(segment=>segment.index+segment.text.search(/\S/u));
}

export function sentenceTarget(blocks,index,offset,direction,language='en'){
  if(index<0||index>=blocks.length)return null;
  const starts=sentenceStarts(blocks[index].textContent,language);
  const target=direction<0?starts.filter(start=>start<offset).at(-1):starts.find(start=>start>offset);
  if(target!==undefined)return {index,offset:target};
  const adjacent=index+(direction<0?-1:1);
  if(adjacent<0||adjacent>=blocks.length)return null;
  const other=sentenceStarts(blocks[adjacent].textContent,language);
  if(!other.length)return null;
  return {index:adjacent,offset:direction<0?other.at(-1):other[0]};
}
